import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { NbAuthService, NbAuthToken } from '@nebular/auth';
import { LaddaService } from '../services/ladda.service';
import { ErrorHandlerService } from '../services/error-handler.service';
import  moment from 'moment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private count = 0;

    constructor(
        private injector: Injector,
        private ladda: LaddaService,
        private errorHandlerService: ErrorHandlerService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return this.authService.isAuthenticated()
            .pipe(
                switchMap(authenticated => {
                    if (authenticated) {
                        return this.authService.getToken().pipe(
                            switchMap((token: NbAuthToken) => {
                                this.count++;

                                if (this.count === 1) {
                                    if (
                                        req.method === 'POST' ||
                                        req.method === 'PUT' ||
                                        req.method === 'PATCH'
                                    ) {
                                        this.ladda.show();
                                    }
                                }

                                const JWT = `Bearer ${token.getValue()}`;
                                req = req.clone({
                                    setHeaders: {
                                        Authorization: JWT,
                                        TimezoneOffset: (new Date().getTimezoneOffset() / 60).toString(),
                                        'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
                                        'Pragma': 'no-cache',
                                        'Expires': '0'
                                    },
                                });
                                return next.handle(req).pipe(
                                    catchError((err: any) => this.errorHandlerService.handleErr(err, req.url)),
                                    finalize(() => {
                                        this.count = 0;
                                        if (
                                            req.method === 'POST' ||
                                            req.method === 'PUT' ||
                                            req.method === 'PATCH'
                                        ) {
                                            this.ladda.hide();
                                        }
                                        return;
                                    }),
                                );
                            }),
                        );
                    } else {
                        // Request is sent to server without authentication so that the client code
                        // receives the 401/403 error and can act as desired ('session expired', redirect to login, aso)
                        return next.handle(req).pipe(
                            catchError((err: any) => this.errorHandlerService.handleErr(err, req.url)),
                            finalize(() => {
                                return;
                            }),
                        );
                    }
                }),
            );
    }

    protected get authService(): NbAuthService {
        return this.injector.get(NbAuthService);
    }
}
